import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '88%',
    padding: '3% 3%',
    margin: 'auto',
    minWidth: '1200px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#666666',
    marginBottom: 7,
  },

  contentPaper: {
    margin: '0px !important',
    border: '1px solid #CCCCCC',
  },
  gridMargin: {
    padding: '12px',
  },
  invoiceTbleContainer: {
    maxHeight: 'calc(100vh - 225px)',
    border: '1px solid #e5e5e5',
  },
  container: { marginBottom: 32 },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  input: {
    height: 40,
    paddingRight: 0,
    width: 150,
  },
  inputDatePicker: {
    height: 40,
    paddingRight: 0,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#666666',
  },

  inputStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#666666',
  },
  dropdownStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  datePicker: {
    width: 150,
    marginTop: 0,
    paddingRight: 0,
  },
  helperText: {
    marginLeft: 0,
    marginRight: 0,
    fontSize: '10px',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'capitalize',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    color: '#ffff',
    margin: 'auto',
    marginBottom: 16,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  clearFilerDisabledButton: {
    fontFamily: 'HelveticaNeueLTStd-Cn',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    color: '#666666',
    textTransform: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  clearFilerButton: {
    fontFamily: 'HelveticaNeueLTStd-Cn',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '20px',
    color: '#DF0C36',
    textTransform: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  autocompleteInput: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
    height: 18,
    paddingLeft: ' 0 !important',
  },
  autocomplete: {
    marginRight: 16,
    width: 150,
  },
  option: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#666666',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },

  paper: {
    width: '100%',
  },
  table: {
    minWidth: 750,
    borderCollapse: 'collapse',
  },
  tableHead: {
    height: '40px',
    fontSize: '14px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#666666',
    paddingTop: '0px',
    paddingBottom: '0px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  checkboxTableHead: {
    height: '40px',
    fontSize: '14px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#666666',
    padding: '0px 12px',
    cursor: 'pointer',
    position: 'relative',
  },
  tableCell: {
    fontSize: '12px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    borderWidth: 1,
    color: '#666666',
    whiteSpace: 'nowrap',
    padding: '12px 10px',
  },
  selectIcon: {
    color: '#DF0C36',
  },
  actions: {
    color: '#DF0C36',
  },
  paginationBox: {
    borderTop: '1px solid #e5e5e5',
  },
  checkbox: {
    color: '#666666 !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    padding: '0px 0px',
  },
  checkboxSelected: {
    color: '#DF0C36 !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    padding: '0px 0px',
  },
  downloadInvoiceFile: {
    textDecoration: 'underline',
    textTransform: 'none',
    color: '#0062B8',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '20px',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  editButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    backgroundColor: '#DF0C36',
    color: 'white',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '16%',
    marginRight: '3%',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  fixedGridWidth: {
    maxWidth: 1600,
  },
  saveButton: {
    color: 'white',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '19%',
    marginRight: '3%',
    backgroundColor: '#DF0C36',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 5px white',
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    color: '#DF0C36',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '16%',
    marginRight: '3%',
    boxShadow: '0px 15px 20px rgb(217 224 221 / 40%)',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  arrowSorting: {
    color: '#DF0C36 !important',
    opacity: '1 !important',
  },
  supplierList: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px',
    color: '#666666',
    textTransform: 'capitalize',
  },
}));
